import { createContext } from 'react'
import { StockStoreTypeEnum } from '../config'
export const FreshList = createContext({
  fresh: () => {}
})
export const ShowAddSheet = createContext({
  show: false
})

export const StoreCode = createContext({
  storeCode: ''
})

export const StockStoreType = createContext({
  stockStoreType: StockStoreTypeEnum[0]
})
